import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/_shared/components/modal/modal.service';
import { AdministrativeIndicationsReportService } from 'src/app/services/administrative-indications-report-v2.service';
import {
  DoctorV2Service,
  ListDoctorsResponse,
} from 'src/app/services/doctor-v2.service';
import { UiIndicationLaudosModalComponent } from 'src/app/shared/components/ui-indication-laudos-modal/ui-indication-laudos-modal.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-administrative-indications',
  templateUrl: './indication-financial.component.html',
  styleUrls: ['./indication-financial.component.scss'],
})
export class AdministrativeIndicationsFinancialComponent implements OnInit {
  loading = false;
  exporting = false;
  filtersApplied = false;
  assasLink = environment.asaasInvoiceLink;

  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  displayedColumns: string[] = [
    'indicationId',
    'accountName',
    'documentUrl',
    'status',
    'scheduleDate',
    'doctorName',
    'transactionAmount',
    'previdasAmount',
    'doctorAmount',
    'paymentMethod',
    'invoiceId',
  ];

  total = 0;
  pageIndex = 0;
  pageSize = 10;

  filters: FormGroup;

  doctorOptions: ListDoctorsResponse[] = [];
  private subs = new Subscription();
  private readonly modalService = inject(ModalService);

  constructor(
    private readonly service: AdministrativeIndicationsReportService,
    private readonly doctorService: DoctorV2Service,
    private readonly fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.listDoctors();

    this.filters = this.fb.group({
      hasDocument: [],
      dateFrom: [],
      dateTo: [],
      doctorId: [],
      status: [],
    });

    this.onSearch();
  }

  onSearch(event?: PageEvent): void {
    this.loading = true;

    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    } else {
      this.pageIndex = 0;
    }

    const baseFilter: any = {};
    const filterFormValues = this.filters.getRawValue();
    console.log(filterFormValues);

    if (
      filterFormValues.hasDocument !== undefined ||
      filterFormValues.hasDocument !== null
    ) {
      baseFilter.hasDocument = filterFormValues.hasDocument;
    }

    const schedules: any = {};
    if (filterFormValues.dateFrom && filterFormValues.dateTo) {
      const dateFrom = this.formatDateToYMD(filterFormValues.dateFrom);
      const dateTo = this.formatDateToYMD(filterFormValues.dateTo);

      console.log('dateFrom', dateFrom);

      schedules.date = [`${dateFrom}T00:00:00`, `${dateTo}T23:59:59`];
    }

    if (filterFormValues.doctorId) {
      schedules.doctorId = filterFormValues.doctorId;
    }

    if (schedules) {
      baseFilter.schedules = schedules;
    }

    if (filterFormValues.status) {
      baseFilter.status = filterFormValues.status;
    }

    this.service
      .searchFinancial({
        filter: baseFilter,
        page: this.pageIndex + 1,
        perPage: this.pageSize,
      })
      .subscribe(
        (datatable) => {
          this.dataSource.data = [...(datatable.rows || [])];
          this.total = datatable.total || 0;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  openLaudosModal(row: any): void {
    if (!row.hasDocument) return;

    this.modalService.open({
      component: UiIndicationLaudosModalComponent,
      data: {
        indicationId: row.id,
        patientName: row.patient?.name ?? '',
        cpf: row.patient?.cpf ?? '',
      },
      width: '640px',
      maxWidth: 'calc(100vw - 32px)',
    });
  }

  generateInvoiceLink(nfeId: string): string {
    const id = nfeId.replace(/^inv_0*/, '');
    return `${this.assasLink}/${id}`;
  }

  generateInvoiceId(nfeId: string): string {
    const onlyNumbers = nfeId.replace(/\D/g, '');
    const noLeadingZeros = onlyNumbers.replace(/^0+/, '');
    return noLeadingZeros;
  }

  formatDateToYMD(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  clearFilter() {
    this.filters.setValue({
      hasDocument: null,
      dateFrom: null,
      dateTo: null,
      doctorId: null,
      status: null,
    });

    this.onSearch();
  }

  private listDoctors() {
    this.doctorService.findAll().subscribe((doctors) => {
      this.doctorOptions = doctors;
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
